import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import BobineLogo from '../components/BobineLogo';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;
const serif = "'Georgia', 'Times New Roman', serif";

const SasAlertsPreviewPage = () => {
  const navigate = useNavigate();
  const [previews, setPreviews] = useState(null);
  const [activeAlert, setActiveAlert] = useState('j7');
  const [error, setError] = useState('');

  useEffect(() => {
    const adminKey = localStorage.getItem('bobine_admin_key') || 'bobine-admin-2026';
    axios.get(`${API}/admin/sas-alerts-preview`, {
      headers: { 'X-Admin-Key': adminKey }
    }).then(res => {
      if (res.data.previews) setPreviews(res.data.previews);
    }).catch(() => setError('Accès réservé aux administrateurs'));
  }, []);

  const alertLabels = {
    j7: { label: 'J-7 — Bienveillant', color: '#D4AF37' },
    j3: { label: 'J-3 — Rappel', color: '#E8A317' },
    j1: { label: 'J-1 — Urgence', color: '#C0392B' },
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#000' }}>
      <header style={{ borderBottom: '1px solid rgba(212,175,55,0.2)' }}>
        <div className="container mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <BobineLogo size={22} />
          <button onClick={() => navigate('/admin')} style={{ fontFamily: serif, fontSize: 12, padding: '6px 14px', borderRadius: 6, cursor: 'pointer', color: '#D4AF37', border: '1px solid rgba(212,175,55,0.3)', backgroundColor: 'transparent' }}>
            Retour Admin
          </button>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <div style={{ marginBottom: 24 }}>
          <button onClick={() => navigate('/admin')} data-testid="back-btn"
            style={{ fontFamily: serif, fontSize: 14, padding: '10px 20px', borderRadius: 8, cursor: 'pointer', color: '#D4AF37', backgroundColor: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.3)', display: 'flex', alignItems: 'center', gap: 6, fontWeight: 500 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            Retour
          </button>
        </div>

        <h1 style={{ fontFamily: serif, fontSize: 28, color: '#D4AF37', textAlign: 'center', marginBottom: 8 }}>
          Alertes Sas de Tri
        </h1>
        <p style={{ fontFamily: serif, fontSize: 13, color: '#FAF3E0', textAlign: 'center', marginBottom: 32, fontStyle: 'italic' }}>
          Aperçu des 3 emails envoyés automatiquement avant la suppression des photos du Sas
        </p>

        {error && <p style={{ textAlign: 'center', color: '#c0392b', fontFamily: serif }}>{error}</p>}

        {previews && (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: 24, flexWrap: 'wrap' }}>
              {Object.keys(alertLabels).map(key => (
                <button key={key} onClick={() => setActiveAlert(key)} data-testid={`preview-tab-${key}`}
                  style={{
                    fontFamily: serif, fontSize: 13, padding: '8px 20px', borderRadius: 8, cursor: 'pointer',
                    backgroundColor: activeAlert === key ? alertLabels[key].color : 'transparent',
                    color: activeAlert === key ? '#000' : alertLabels[key].color,
                    border: `1px solid ${alertLabels[key].color}50`,
                    fontWeight: activeAlert === key ? 600 : 400, transition: 'all 0.3s',
                  }}>
                  {alertLabels[key].label}
                </button>
              ))}
            </div>

            <div data-testid="email-preview" style={{
              borderRadius: 12, overflow: 'hidden',
              border: `1px solid ${alertLabels[activeAlert].color}40`,
              backgroundColor: '#f9f8f4',
            }}>
              <div dangerouslySetInnerHTML={{ __html: previews[activeAlert] }} />
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default SasAlertsPreviewPage;
